<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-resources__type" @click="sortColumn('resourcesName')">
						{{ $t('resourcesName') }}
					</th>
					<th
						class="th-resources__type"
						@click="sortColumn('resourcesCategory')"
					>
						{{ $t('resourcesCategory') }}
					</th>
					<th
						class="th-resources__type"
						@click="sortColumn('resourcesDescription')"
					>
						{{ $t('description') }}
					</th>
					<th class="th-resources__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr v-for="(row, index) in data" :key="index" class="table-row">
					<td>{{ row.name }}</td>
					<td>{{ row.category == null ? '' : row.category.name }}</td>
					<td>{{ row.description }}</td>
					<td class="td-center">
						<button class="action-button" @click="editRow(row)">
							<svgicon v-if="isEnable" name="pencil"></svgicon>
							<svgicon v-if="!isEnable" name="search"></svgicon>
						</button>
						<button class="action-button" @click="openDeleteModal(row)">
							<svgicon name="trash"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="data.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteResource()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: $t('resource')
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import AdminFacility from '@/mixins/AdminFacility';
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination
	},
	mixins: [AdminFacility],
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			currentPage: 1,
			itemsPerPage: 50,
			resourcesNameIndex: 0,
			deleteRow: null
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	methods: {
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		openDeleteModal(row) {
			this.deleteRow = row;
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteResource() {
			this.$emit('deleteRow', this.deleteRow);
			this.showMessageDeletionModal = false;
		},
		openMessageDeletionModal() {
			this.showMessageDeletionModal = true;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		isEnable() {
			return (
				(this.isSuperAdmin || this.isUSAAdmin) && this.selectedFacilityId == 0
			);
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}

.th-resources {
	&__type {
		width: 30%;
	}
	&__actions {
		width: 10%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}

.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
